
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./client-models.cjs.production.min.js')
} else {
  module.exports = require('./client-models.cjs.development.js')
}
